import { render, staticRenderFns } from "./insight.vue?vue&type=template&id=63f5f70e&scoped=true"
import script from "./insight.vue?vue&type=script&lang=js"
export * from "./insight.vue?vue&type=script&lang=js"
import style0 from "./insight.vue?vue&type=style&index=0&id=63f5f70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5f70e",
  null
  
)

export default component.exports